module.exports = __webpack_public_path__ + "web/img/articles2.48723d43.png";